<template>
    <div class="withdraw_page">
    <WithdrawTopCard :text="$t('common.withdraw')" :sub-text="$t('common.subText')"
        @close-popup="backNavigate" :show-fund="true" @go-to-fund="goToFund"  :hideBacKIcon="footerSelected == '3'"/>
        <div style="height: 160px; background-color: #024A49;"></div>
    <div class="withdraw_container">     
        <div 
            :class="[
                'channel_container_top',
                dataSet.activeChannel.channelType == '6' ? 'channel_container_top_crypto' : ''
            ]">
            <div class="line" ></div> 
            <div class="channel_text_title">{{ $t('common.paymentChannelTitle') }}</div>
            <div class="channel_list">
                <div class="channel_card" v-for="item in dataSet.channelList" :key="item.name"
                    :class="dataSet.activeChannel.id == item.id ? 'active_channel' : ''" @click="selectChannel(item)">
                    {{ item.name }}
                </div>
            </div>
            <div class="channel_text" v-if="dataSet.activeChannel.channelType != '6'" >{{ $t('common.paymentChannelTotal') }} <span class="currency"> R$ {{ formatCurrency(dataSet?.balanceAmount || 0) }} </span></div>
        </div>
        <CryptoWithdraw v-if="dataSet.activeChannel.channelType == '6'"  />
        <div v-else>
            <div class="channel_container_center">    
                <div style="padding: 0px 16px;">
                    <!-- <div class="channel_text_select">{{ $t('common.withdrawalAmt') }}</div> -->
                     <InputField 
                    :modelValue="selectedAmount"
                    :labelText="`${formatCurrency(minAmount)} - ${formatCurrency(maxAmount)}`"
                    @valueChanged="inputValueChange"
                    :maxLimit="dataSet.balanceAmount"
                    />     
                    <van-row class="amount_card_list">
                    <van-col span="8" v-for="item in amountList" :key="item.fillValue" style="padding: 10px 5px;">
                        <AmountCard :amount="item.fillValue" :isActiveAmount="selectedAmount == item.fillValue"
                            @handleCardClick="selectAmount(item.fillValue)" />
                    </van-col>
                   </van-row>
                               
                </div>
            </div>
            <div class="channel_container">
                <WithdrawViewTwo ref="withdrawRef" v-model:data-set-two="dataSetTwo"
                    @confirm-withdraw-popup="confirmWithdrawUserId" @input-value-change="inputValueChange"
                    @select-channel="selectChannel" @select-tab-type="selectTabType"
                    @update-form-values="updateWithdrawFormValues" @change-value="changeValues"
                    @check-fields-fill="checkFieldsFill" />
            </div>
            <div class="btn_container">
                <MainButton :title="$t('common.retirarAgora')" :activeStatus="isMainButtonActive"
                    @click="withdrawRef?.confirmWithdraw()" :radius="'8px'" :btn-padding="'28px'" :forceGradientWhenDisabled="true"/>
            </div>
        </div>
        <div v-if="dataSet?.withdrawControls?.length > 0" class="descriptionContainer">
            <div class="noticeText">{{ $t('common.notice') }}</div>
            <van-row class="tabelHeader">
                 <van-col span="12" class="tabeldata">{{ $t('withdraw.rechargeTimes') }}</van-col>
                <van-col span="12" class="tabeldata"> {{ $t('withdraw.rechargeAmount')}}</van-col>
            </van-row>
            <van-row v-for="(item,index) in dataSet?.withdrawControls" :key="index" :class="index % 2 === 0 ? 'row-dark' : 'row-light'">
                 <van-col span="12" class="tabeldata">{{ item.rechargeTime }} X</van-col>
                <van-col span="12" class="tabeldata"> {{ item.minAmount }}</van-col>
            </van-row>
        </div>
         <div v-if="userStore.footerComponent && footerSelected != '4'">
            <MainFooter :itemData="userStore.footerComponent" :activeFooter="4" />
        </div>
    </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, reactive } from 'vue'
import InputField from '../withdraw/components/inputField.vue';
import { PayChannel } from '@/types/common';
import { formatCurrency } from '@/utils/commonFunction';
import { Channel, TAB_TYPE_LIST, WithdrawPopupData, WithdrawViewData } from '@/view/withdraw/supportScript';
import WithdrawViewTwo from './withdrawPopup.vue';
import { useWithdrawStore } from '@/stores/withdraw';
import { useUserStore } from '@/stores/user';
import { withdraw, withdrawSettingByUserID } from '@/api/withdraw';
import MainButton from '../components/common/mainButton.vue';
import CryptoWithdraw from './cryptoWithdraw.vue';
import { useRouter } from 'vue-router';
import WithdrawTopCard from '../components/common/topHeaderCard.vue';
import CustomHeader from '../components/common/customHeader.vue';
import AmountCard from './components/amountCard.vue';
import MainFooter from '../components/common/mainFooter.vue';
import { showToast } from 'vant';
import 'vant/es/toast/style';
const emits = defineEmits(['selectChannel', 'showError', 'showSuccess', 'showLoading', 'inputValueChange'])
const withdrawStore = useWithdrawStore()
const userStore = useUserStore()
const router = useRouter()
const uId = computed(() => userStore.id)
const props = defineProps<{
    dataSet: WithdrawViewData
}>()
const withdrawRef = ref<InstanceType<typeof WithdrawViewTwo>>()
const footerSelected = localStorage.getItem('footerPopupOpen')
const selectedChannel = computed(() => withdrawStore.selectedChannel as Channel)
const activeTab = ref(TAB_TYPE_LIST[0])
const cpfID = ref('')
const emailID = ref('')
const phoneID = ref('')
const evpID = ref('')
const userName = ref('')
const cpfNumber = ref('')
const brazilID = ref('')
const bank = ref('')
const showCPFIdError = ref(true)
const showEmaiIdError = ref(true)
const showPhoneIdError = ref(true)
const showEvpIdError = ref(true)
const showCPFNumError = ref(false)
const activeButton = ref(props.dataSet.activeButton)
const isActiveButton = ref(false)
const selectedAmount = ref()
const isDisabled = ref(false)

const formValues = ref({
    cpfID: '',
    emailID: '',
    phoneID: '',
    evpID: '',
    userName: '',
    cpfNumber: '',
    brazilID: '',
    bank: '',
})

const dataSetTwo = reactive<WithdrawPopupData>({
    // show: show.value,
    selectedChannel: selectedChannel.value,
    activeTab: activeTab.value,
    cpfID: cpfID.value,
    emailID: emailID.value,
    phoneID: phoneID.value,
    evpID: evpID.value,
    userName: userName.value,
    cpfNumber: cpfNumber.value,
    brazilID: brazilID.value,
    bank: bank.value,
    showCPFIdError: showCPFIdError.value,
    showEmaiIdError: showEmaiIdError.value,
    showPhoneIdError: showPhoneIdError.value,
    showEvpIdError: showEvpIdError.value,
    showCPFNumError: showCPFNumError.value,
    activeButton: activeButton.value,
    selectedAmount: selectedAmount.value,
    isDisabled: isDisabled.value,
})

const amountList = ref([
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": 1,
        "updateTime": "2026-02-27 08:24:21",
        "tenantId": "000000",
        "id": 3,
        "fillValue": 10,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": null,
        "updateTime": "2026-01-08 07:37:17",
        "tenantId": "000000",
        "id": 4,
        "fillValue": 30,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": 1,
        "updateTime": "2026-01-08 07:37:16",
        "tenantId": "000000",
        "id": 5,
        "fillValue": 50,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": null,
        "updateTime": "2026-01-08 07:37:14",
        "tenantId": "000000",
        "id": 7,
        "fillValue": 100,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": 1,
        "updateTime": "2026-01-08 07:37:13",
        "tenantId": "000000",
        "id": 8,
        "fillValue": 300,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": null,
        "updateTime": "2025-07-07 05:06:19",
        "tenantId": "000000",
        "id": 9,
        "fillValue": 500,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": null,
        "updateTime": "2025-08-12 10:20:43",
        "tenantId": "000000",
        "id": 10,
        "fillValue": 1000,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    },
    {
        "createDept": 103,
        "createBy": 1,
        "createTime": "2025-07-07 01:30:13",
        "updateBy": 1,
        "updateTime": "2025-07-07 07:13:41",
        "tenantId": "000000",
        "id": 11,
        "fillValue": 30000,
        "giftRatio": 0,
        "codingRequirement": 0,
        "turnover": 0,
        "status": 1,
        "type": 1
    }
])

const minAmount = computed(() => {
  if (!amountList.value.length) return 0
  return Math.min(...amountList.value.map(item => item.fillValue))
})

const maxAmount = computed(() => {
  if (!amountList.value.length) return 0
  return Math.max(...amountList.value.map(item => item.fillValue))
})

const isMainButtonActive = computed(() => props.dataSet.activeButton && isActiveButton.value)

const updateWithdrawFormValues = (values: any) => {
    formValues.value = { ...formValues.value, ...values }
}

const selectChannel = (item: PayChannel) => {
    emits('selectChannel', item)
}

const selectTabType = (item: any) => {
    activeTab.value = item
}

const confirmWithdrawUserId = () => {
    const data = { uid: uId.value }
    withdrawSettingByUserID(data)
        .then((res) => {
            confirmWithdrawApi()
        })
        .catch((err) => {
            if (err.code != 401) {
                emits('showError', err)
            }
        })
}

const confirmWithdrawApi = () => {
    emits('showLoading', true)
    const active = activeTab.value.name

    const data: any = {
        payment_channel_id: selectedChannel.value.id,
        amount: selectedAmount.value,
        tax_type: active,
        tax_id:
            active === 'CPF'
                ? formValues.value.cpfID
                : active === 'E-mail'
                    ? formValues.value.emailID
                    : active === 'PHONE'
                        ? formValues.value.phoneID
                        : active === 'EVP'
                            ? formValues.value.evpID
                            : '',
        account_name: formValues.value.userName,
        cpf_id: formValues.value.cpfNumber,
        uid: uId.value,
    }

    if (selectedChannel.value.channelType === '1') {
        data.bank_name = formValues.value.bank
    } else if (selectedChannel.value.channelType === '7') {
        data.bank_name = formValues.value.bank
        data.identity_no = formValues.value.brazilID
    }

    withdraw(data)
        .then((res) => {
            emits('showLoading', false)
            emits('showSuccess', res.msg)
            setTimeout(() => {
                userStore.getInfo()
            }, 500)
        })
        .catch((err) => {
            emits('showLoading', false)
            emits('showError', err)
            setTimeout(() => {
                userStore.getInfo()
            }, 500)
        })
}

const getWithdrawDetails = () => {
    let data = { uid: uId.value }
    withdrawSettingByUserID(data)
        .then(res => {
            const resData = res.data
            if (resData == null) return
            withdrawStore.setWithdrawInfo(resData)
            dataSetTwo.cpfID = resData?.cpf || ''
            dataSetTwo.emailID = resData?.email || ''
            dataSetTwo.phoneID = resData?.phone || ''
            dataSetTwo.evpID = resData?.evpId || ''
            dataSetTwo.userName = resData?.userName || ''
            dataSetTwo.cpfNumber = resData?.cpfId || ''
            dataSetTwo.brazilID = resData?.identityNo || ''
            dataSetTwo.isDisabled = resData?.isEditable == 1
        })
        .catch((err) => {
            if (err.code != 401) {
                emits('showError', err)
            }
        })
}

const changeValues = (data: any) => {
    if (data.type === 'cpfID') {
        cpfID.value = data.value
    } else if (data.type === 'emailID') {
        emailID.value = data.value
    } else if (data.type === 'phoneID') {
        phoneID.value = data.value
    } else if (data.type === 'evpID') {
        evpID.value = data.value
    } else if (data.type === 'cpfNumber') {
        cpfNumber.value = data.value
    } else if (data.type === 'userName') {
        userName.value = data.value
    } else if (data.type === 'brazilID') {
        brazilID.value = data.value
    } else if (data.type === 'bank') {
        bank.value = data.value
    }
}

const checkFieldsFill = (isActive: any) => {
    isActiveButton.value = isActive
}

const inputValueChange = (val: any) => {
    const currentBalance = props.dataSet?.balanceAmount ?? 0
    if (currentBalance < val) {
        selectedAmount.value = currentBalance
        
    } else {
        selectedAmount.value = val
    }
    // if (val > 0 && isActiveButton.value) {
    //     activeButton.value = true
    // } else {
    //     activeButton.value = false
    // }
    emits('inputValueChange', val)
    
}

const selectAmount = (val: number) => {

    const currentBalance = props.dataSet?.balanceAmount ?? 0

    if (val > currentBalance) {
        selectedAmount.value = currentBalance
        showToast('Saldo da conta insuficiente');
    } else {
        selectedAmount.value = val
    }
    inputValueChange(selectedAmount.value)
}

const backNavigate = () => {
    userStore.setRechargeBonusType(0)
    userStore.setTakeFirstDeposit(false)
    router.go(-1)
}
const goToFund = () => {
    router.replace({ path: '/fundsHistory', query: { tabIndex: 1 } })
}

onMounted(() => {
    getWithdrawDetails()
})
</script>
<style scoped>
.withdraw_container {
    /* margin-top: 150px;  */
    background: #003130;
    padding-bottom: 20%;
    min-height: 100vh;
    padding-bottom: 20vh;
}

.channel_text {
    color: #FFFF;
    font-size: 18px;
    padding:10px 0px;
    font-weight: bold;
}

.channel_text_select {
    color: #FFFF;
    font-size: 17px;
    padding: 10px 0px;
    font-weight: bold;
}

.currency{
    color: #FBA531;
    /* gold for "R$" */
    margin-left: 4px;
    font-weight: bold;
}

.channel_text_title{
   color: #FFFF;
    font-size: 15px;
    padding:10px 0px 0px;
    font-weight: bold; 
}

.channel_list {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    gap: 0px;    
    padding: 10px;
}

.channel_list::-webkit-scrollbar {
    display: none;
}


.line {
    height: 1.5px;
    width: 100%;
    background: rgb(0, 97, 95);
}

.btn_container {
    padding: 30px 16px;
}

.balance_container {
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: 3vh;
}

.balance_text {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.65);
}

.balance_value {
    color: rgba(255, 255, 255, 0.85);
    font-size: 45px;
}

.sub_container {
    font-size: 15px;
    color: rgba(255, 255, 255, 0.85);
    padding: 0 25px;
}

.sub_container ::v-deep .van-field {
    border-radius: 10px;
    padding: 2vh !important
}

.btn_container ::v-deep .defaultButton .van-button--default {
    padding: 1.5vw 0;
}

.top-banner {
    padding: 5px 15px;
}

.top-banner img {
    width: 100%;
    border-radius: 20px;
}

.channel_container {
    font-size: 14px;
    border-radius: 12px;
}

.channel_container_center{
    background-color: #024A49; 
    padding-bottom: 20px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}

.channel_container_top {
    background-color: #024A49;
    font-size: 14px;
    padding: 0px 15px
}

.channel_container_top_crypto{
    background-color: #024A49;
    font-size: 14px;
    padding: 0px 15px 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}

.channel_list {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    padding: 10px 0px 10px 0px;
    
}

.channel_list::-webkit-scrollbar {
    display: none;
}

.channel_card {
    border-radius: 8px;
    color: #ffffff;
    background-color: #ffffff26;
     display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 6px;
    margin: 0 5px;
    font-size: 17px;
    font-weight: 700;
    height: 28px;
    width: 100%;
}

.active_channel {
    background: rgb(13, 176, 174);
    color: #ffffff;
    border-radius: 8px;
}

.amount-info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 10px 10px;
    font-size: 13px;
    color: #ffffffb3;
    /* soft white */
}

.fee-total-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    padding: 0 4px;
    font-size: 14px;
    font-weight: 600;
    color: #FFF;
    /* soft purple text */
}

.currency {
    color: #FBA531;
    /* gold for "R$" */
    margin-left: 4px;
    font-weight: bold;
}

.highlight {
    color: #35a5f8;
    /* gold for amount */
    margin-left: 2px;
    font-weight: bold;
}

.withdrawNotice {
    display: flex;
    align-items: center;
    background: #ffffff26;
    border-radius: 5px;
    color: #ffffff87;
    padding: 15px;
    font-size: 14px;
    margin: 10px 0px;
}
.noticeText{
    font-size: 14px;
    font-weight: bold;
    padding: 0 0 5px;
    /* color: #f3a7f8; */
}
.descriptionContainer {
    padding: 15px;
    background: #ffffff2f;
    font-size: 12px;
    color: #fff;
    border-radius: 10px;
    margin: 0 15px;
}
.tabelHeader{
   font-size: 12px;
    color: #fff; 
    font-weight: bold;
    padding: 5px;
    background: #ffffff21;
}
.tabeldata{
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    padding: 5px;
}
.row-dark {
    background-color: #f8f8f838; 
}

.row-light {
    background-color: #ffffff52; 
}
@media (max-width: 450px) {
    .fee-total-row {
        font-size: 11px;
        /* smaller font for mobile */
    }

    .fee-total-row .currency,
    .fee-total-row .highlight {
        font-size: 12px;
        /* adjust R$ and amount font if needed */
    }
}

@media (min-width: 1440px) {
    .channel_text {
        font-size: 18px;
    }

    .channel_card,
    .balance_text,
    .sub_container,
    .sub_container ::v-deep .van-field,
    .btn_container ::v-deep .defaultButton .van-button--default {
        font-size: 18px;
    }

    /* .active_channel {
        padding: 15px 3vh !important;
    } */
}

@media (min-width: 1920px) {
    .channel_text {
        font-size: 18px;
    }

    .channel_card,
    .balance_text,
    .sub_container,
    .sub_container ::v-deep .van-field,
    .btn_container ::v-deep .defaultButton .van-button--default {
        font-size:2.1vh;
    }

    /* .active_channel {
        padding: 15px 3vh !important;
    } */
}

@media (max-width: 360px) {
  .channel_card {
    min-width: 70px;
    font-size: 12px;
    padding: 5px;
    height: 26px;
  }

  .channel_text {
    font-size: 14px;
    padding-top: 15px;
  }
}

</style>